'use client';

import React, { createContext, useContext } from 'react';

export interface SitePreferences {
  [key: string]: any;
}
const SitePreferencesContext = createContext<any>(null);

export function SitePreferencesProvider({ value, children }: { value: SitePreferences; children: React.ReactNode }) {
  return <SitePreferencesContext.Provider value={value}>{children}</SitePreferencesContext.Provider>;
}

export function useSitePreferences() {
  const ctx = useContext(SitePreferencesContext);
  if (!ctx) {
    throw new Error('useSitePreferences must be used within SitePreferencesProvider');
  }
  return ctx || {};
}
